
    import {useConnectLogin} from "./src/utils/toggleConnectOdp.js";

    if (useConnectLogin()) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '/OidcTrustedDomains.js';
        script.defer = true;
        document.head.appendChild(script);

        const scriptSW = document.createElement('script');
        scriptSW.type = 'text/javascript';
        scriptSW.src = '/OidcServiceWorker.js';
        scriptSW.defer = true;
        document.head.appendChild(scriptSW);
        import('./src/index_connect.jsx')
            .then((module) => {
                console.log('Loaded index_connect:', module);
            })
            .catch((error) => {
                console.error('Error loading index_connect:', error);
            });
    } else {
        if (window.navigator && navigator.serviceWorker) {
            navigator.serviceWorker.getRegistrations()
                .then(function (registrations) {
                    for (let registration of registrations) {
                        //if (registration.scope.includes(window.location.origin))
                        registration.unregister();
                        console.log("Service Worker unregistered " + registration);
                    }
                });
        }

        if(window.caches){
            window.caches.keys().then(function(cacheNames) {
                cacheNames.forEach(function(cacheName) {
                    window.caches.delete(cacheName);
                });
            });
        }

        if(window.localStorage.getItem('oidc.login.default'))
            window.localStorage.removeItem('oidc.login.default')
        if(window.localStorage.getItem('oidc.server:https://connect.identity.stagaws.visma.com'))
            window.localStorage.removeItem('oidc.server:https://connect.identity.stagaws.visma.com')
        if(window.localStorage.getItem('oidc.server:https://connect.visma.com'))
            window.localStorage.removeItem('oidc.server:https://connect.visma.com')


        import('./src/index.jsx')
            .then((module) => {
                console.log('Loaded index:', module);
            })
            .catch((error) => {
                console.error('Error loading index:', error);
            });
    }
